/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import type { MessageDescriptor } from "react-intl";
import { useUser } from "../../shared";
import { useNameValidator } from "../../../../shared";

const validationState = {
  validUserInfo: false,
  nameErrors: [] as MessageDescriptor[],
  surnameErrors: [] as MessageDescriptor[],
};

export function useUserInfo() {
  const [user, status, saveUserInfo] = useUser();
  const [department, setDepartment] = useState(1);
  const [name, setName] = useState<string | undefined>("");
  const [surname, setSurname] = useState<string | undefined>("");
  const [profilePicture, setProfilePicture] = useState<string>("");
  const [validation, setValidation] = useState(validationState);
  const [nameValid, nameErrors] = useNameValidator(name, "name");
  const [surnameValid, surnameErrors] = useNameValidator(surname, "surname");
  const [image, setImage] = useState<File | Blob | undefined>();

  useEffect(() => {
    setValidation({
      validUserInfo: nameValid && surnameValid,
      nameErrors,
      surnameErrors,
    });
  }, [nameValid, surnameValid, nameErrors, surnameErrors]);

  const resetUserInfo = useMemo(
    () => () => {
      setName(user.name);
      setSurname(user.surname);
      setDepartment(user.departmentId || 1);
      setProfilePicture(user.profilePicture);
    },
    [user],
  );

  const apply = useMemo(
    () => () => {
      saveUserInfo(
        {
          name: name!,
          surname: surname!,
          departmentId: department,
          profilePicture: profilePicture,
        },
        image,
      );
    },
    [name, surname, department, profilePicture, image],
  );

  useEffect(() => {
    resetUserInfo();
  }, [user]);

  return {
    status,
    name,
    surname,
    department,
    image,
    profilePicture,
    setProfilePicture,
    setName,
    setSurname,
    setDepartment,
    setImage,
    validation,
    apply,
    resetUserInfo,
  };
}
